import { render, staticRenderFns } from "./ChatListItemDummy.vue?vue&type=template&id=f7695d2e&"
import script from "./ChatListItemDummy.vue?vue&type=script&lang=js&"
export * from "./ChatListItemDummy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports